<template>
    <div class="about">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Abouts Us</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="bd">
            <img src="../assets/imgs/uploads/mobile/Group 618.png" style="width: 100vw;" alt="">
            <div class="abs">About us</div>
            <div class="abscnt">
                We are a Hong Kong based company created back in 2010 that has a very simple mission since the first days of
                its establishment: to help people and their pets spend hours of fun together.
                Our commitment to pet needs requires a holistic approach to making toys. It begins by using research to
                understand what sort of materials combined together work best, it continues by bringing together people to
                develop new ideas, and it comes back round by measuring the outcomes of our products.
                We gather exceptional team of professionals from all over the world with various backgrounds, beliefs, and
                perspectives, , but we all share one common dream: develop our products for the better and make you and your
                pet satisfied.
            </div>
        </div>
        <div style="font-size: 5.6vw;color: #282828;font-weight: bold;text-align: center;">Our Vision, Mission, and Values
        </div>
        <div style="margin-top: 9.333vw;">
            <img src="../assets/imgs/uploads/mobile/Group 463.png" style="width: 100vw;" alt="">
        </div>
        <div style="margin: 4.147vw 7.733vw 7.467vw;color: #282828;text-align: center;">
            "Creating a Suite of Globally Influential Pet Product Brands."
        </div>
        <div style="margin-top: 9.333vw;">
            <img src="../assets/imgs/uploads/mobile/Group 461.png" style="width: 100vw;" alt="">
        </div>
        <div style="margin: 4.147vw 7.733vw 7.467vw;color: #282828;text-align: center;">
            "Enhancing the Lives of Pets and People with Aesthetic Product Design."
        </div>
        <div style="margin-top: 9.333vw;">
            <img src="../assets/imgs/uploads/mobile/Group 462.png" style="width: 100vw;" alt="">
        </div>
        <div style="margin: 4.147vw 7.733vw 7.467vw;color: #282828;text-align: center;">
            "Prioritizing User-Centric Products as Supreme, Embracing Innovation as the Key to Industry Leadership and
            Social Benefit."
        </div>
        <div class="bd2">
            <div style="color: #FFF;margin-top: 10.133vw;text-align: center;">
                <p style="font-size: 5.6vw;">“ Design with Heart and Soul ”</p>
                <p style="font-size: 3.467vw;">Discovering and Delivering the Optimal Solutions</p>
            </div>
        </div>
        <div style="margin: 9.067vw 0;font-size: 5.6vw;font-weight: bold;color: #282828;text-align: center;">Why Choose Us
        </div>
        <div>
            <div style="margin-bottom: 6.667vw;padding: 0 7.467vw;font-size: 4vw;">
                <div class="outImg">
                    <img src="../assets/imgs/uploads/ph_factory.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">We own more than 10 self-owned factories in China, Vietnam, Australia, and
                    Canada. We can provide cost-effective products and ample productivity.</p>
                <div class="outImg">
                    <img src="../assets/imgs/uploads/ant-design_safety-outlined.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">We strictly control the entire process from design to shipment and choose
                    safe and high-performance materials.</p>
                <div class="outImg">
                    <img src="../assets/imgs/uploads/fluent-emoji-high-contrast_handshake.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">We stick to long-term cooperation with our partners and aim to become
                    friends, rather than prioritizing our own interests.</p>
                <div class="outImg">
                    <img src="../assets/imgs/uploads/Vector.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">We have the top design team. Most of our products are unique and protected by
                    patents. We continue to develop new products to lead the industry.</p>
                <div class="outImg">
                    <img src="../assets/imgs/uploads/partner 1.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">We can help our partners promote their products in the market. We can provide
                    publicity materials for our partners to post on social media. Additionally, we can support our partners
                    in advertising and participating in exhibitions together.</p>
                <div class="outImg">
                    <img src="../assets/imgs/uploads/worldwide 1.png" alt="" class="Img">
                </div>
                <p style="text-align: center;">Our brands have been established for more than 10 years, and we have also
                    been involved in the pet industry for over 20 years. Our products are sold in more than 30 countries
                    worldwide.</p>
                <div class="b-under">
                    <p style="margin: 8vw 0 1.867vw;font-size: 5.6vw;font-weight: bold;">Contact Us</p>
                    <p style="text-decoration: underline;" target="_blank" href="http://lotus@gigwi.com.hk">xtt@gigwi.com.hk
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.about {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

.bd {
    position: relative;
    margin-bottom: 334px;
}

.abs {
    font-size: 24px;
    font-weight: bold;
    color: #FFF;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.abscnt {
    width: 315px;
    height: 360px;
    background-color: #333;
    padding: 20px;
    font-size: 13px;
    color: #FFF;
    text-align: center;
    position: absolute;
    top: 129px;
    left: 50%;
    transform: translateX(-50%);
}

.bd2 {
    width: 375px;
    height: 141px;
    background-color: #333333;
    overflow: hidden;
}

.outImg {
    display: flex;
    justify-content: center;
    margin: 25px 0 11px;
}

.Img {
    width: 34px;
    height: 34px;
}

.b-under {
    width: 318px;
    height: 114px;
    margin: 33px 0 40px;
    background-color: #F3F3F3;
    overflow: hidden;
    text-align: center;
    border-radius: 15px;
}
</style>